export function checkCookies() {
    let terms = getCookie("terms");
    if (terms === "") {
        document.querySelector('.cookie-bar').style.display = "block";
        setTimeout(() => {
            document.querySelector('.cookie-bar').style.bottom = "30px";
        }, 200);
    }
}

export function setCookies(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    document.querySelector('.cookie-bar').style.bottom = "-500px";
    setTimeout(() => {
        document.querySelector('.cookie-bar').style.display = "none";
    }, 1000);
}

function getCookie(cookieName) {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
